import {
  ADULT_UPPER_RIGHT, ADULT_UPPER_LEFT,
  ADULT_LOWER_RIGHT, ADULT_LOWER_LEFT,
} from './data.js'
import ToothButton from './ToothButton.jsx'

/**
 * 32-tooth permanent dentition picker.
 * Layout follows the dentist's view: patient's right on the left side of the chart.
 *
 * Props:
 *   selected: Set<string> | string[]
 *   onToggle(num): called when a tooth is clicked
 *   readOnly: boolean
 */
export default function AdultToothChart({ selected, onToggle, readOnly }) {
  const sel = toSet(selected)
  return (
    <div className="inline-block">
      {/* Quadrant labels */}
      <div className="flex justify-between text-[11px] uppercase tracking-[0.14em] text-slate-400 font-semibold mb-1.5 px-1">
        <span>Upper Right</span>
        <span>Upper Left</span>
      </div>

      {/* Upper row */}
      <div className="flex items-center gap-1">
        <Row teeth={ADULT_UPPER_RIGHT} sel={sel} onToggle={onToggle} readOnly={readOnly} />
        <div className="w-px h-8 bg-slate-200 mx-0.5" />
        <Row teeth={ADULT_UPPER_LEFT} sel={sel} onToggle={onToggle} readOnly={readOnly} />
      </div>

      {/* Midline */}
      <div className="my-1.5 border-t border-dashed border-slate-200" />

      {/* Lower row */}
      <div className="flex items-center gap-1">
        <Row teeth={ADULT_LOWER_RIGHT} sel={sel} onToggle={onToggle} readOnly={readOnly} />
        <div className="w-px h-8 bg-slate-200 mx-0.5" />
        <Row teeth={ADULT_LOWER_LEFT} sel={sel} onToggle={onToggle} readOnly={readOnly} />
      </div>

      <div className="flex justify-between text-[11px] uppercase tracking-[0.14em] text-slate-400 font-semibold mt-1.5 px-1">
        <span>Lower Right</span>
        <span>Lower Left</span>
      </div>
    </div>
  )
}

function Row({ teeth, sel, onToggle, readOnly }) {
  return (
    <div className="flex items-center gap-1">
      {teeth.map((t) => (
        <ToothButton
          key={t}
          num={t}
          active={sel.has(t)}
          onClick={() => onToggle?.(t)}
          disabled={readOnly}
        />
      ))}
    </div>
  )
}

function toSet(v) {
  if (v instanceof Set) return v
  if (Array.isArray(v)) return new Set(v.map(String))
  return new Set()
}
